<template>
  <DetailList>
    <DetailListHeader title="Perfection" />
    <div class="house-selections">
      <HouseSelect :querent="true" />
      <HouseSelect />
    </div>
    <Perfections />

    <DetailListHeader title="Lots" />
    <DetailListItem title="Part of Fortune" :alt="pof" showFortune />
    <DetailListItem title="Index" asside="Part of Spirit" :alt="index" showIndex />

    <DetailListHeader title="Signs"
      link="https://digitalambler.com/2015/04/03/on-geomantic-figures-zodiac-signs-and-lunar-mansions/" />
    <SignSystem />

    <DetailListHeader title="Figures in the Houses" />
    <DetailListItem title="I" asside="Vita" :figureIndex="1" />
    <DetailListItem title="II" asside="Lucrum" :figureIndex="2" />
    <DetailListItem title="III" asside="Fratres" :figureIndex="3" />
    <DetailListItem title="IV" asside="Genitor" :figureIndex="4" />
    <DetailListItem title="V" asside="Nati" :figureIndex="5" />
    <DetailListItem title="VI" asside="Valetudo" :figureIndex="6" />
    <DetailListItem title="VII" asside="Uxor" :figureIndex="7" />
    <DetailListItem title="VIII" asside="Mors" :figureIndex="8" />
    <DetailListItem title="IX" asside="Itineris" :figureIndex="9" />
    <DetailListItem title="X" asside="Regnum" :figureIndex="10" />
    <DetailListItem title="XI" asside="Benefacta" :figureIndex="11" />
    <DetailListItem title="XII" asside="Carcer" :figureIndex="12" />
  </DetailList>
</template>

<script>
import DetailList from "./DetailList.vue";
import DetailListItem from "./DetailListItem.vue";
import DetailListHeader from "./DetailListHeader.vue";
import HouseSelect from "./HouseSelect.vue";
import Perfections from "./Perfections.vue";
import SignSystem from "./SignSystem.vue";
import Names from "../utils/names";

export default {
  name: "HouseList",
  components: {
    DetailList,
    DetailListItem,
    DetailListHeader,
    HouseSelect,
    Perfections,
    SignSystem
  },
  computed: {
    pof() {
      return "" + this.$store.getters.getPoF;
    },
    index() {
      return "" + this.$store.getters.getIndex;
    }
  },
  methods: {
    figureName(figId) {
      const fig = this.$store.getters.getFigureById(figId);
      return Names.getNameForFigure(fig);
    }
  }
};
</script>

<style lang="scss" scoped>
.house-selections {
  margin-bottom: 10px;
}
</style>
